import { useContext, useEffect, useState } from 'react';

import { useLocation, useNavigate, useParams } from 'react-router';

import Datatable from '../../../Components/Datatable/Datatable';
import Loading from '../../../Components/Loading/Loading';
import TitleBar from '../../../Components/TitleBar/TitleBar';
import { useApi } from '../../../Hooks/Api';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import { CompetitionContext } from '../Context/CompetitionContext';

const UsersTeam = () => {
  const context = useContext(CompetitionContext);
  const { id, teamId } = useParams();
  const navigate = useNavigate();
  const { get, destroy } = useApi();
  const { error, success } = useToast();
  const { search } = useLocation();
  const [loading, setLoading] = useState(true);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalRemoveObject, setModalRemoveObject] = useState(undefined);
  const [removeLoading, setRemoveLoading] = useState(false);
  const [checked, setChcked] = useState([]);

  useEffect(() => {
    const getData = async () => {
      await getUsers();
      await getCompetitionRegister();
    };
    getData();
  }, [id, teamId, search]);

  const getUsers = async () => {
    setLoading(true);
    await get(
      `/users/competition-register/${id}/team/${teamId}?team=true`,
      (res) => {
        context.users = res;
      },
      (err) => {
        error('دریافت اطلاعات شرکت کنندگان با خطا مواجه شد');
        setLoading(false);
      },
    );
  };
  const getCompetitionRegister = async () => {
    setLoading(true);
    await get(
      `/competition-register/${id}`,
      (res) => {
        context.competitionRegister = res?.data;
        setLoading(false);
      },
      (err) => {
        error('دریافت اطلاعات مسابقه با خطا مواجه شد');
        setLoading(false);
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <>
      <Master>
        <TitleBar
          title={`لیست شرکت کنندگان تیمی مسابقه ${context.competitionRegister?.competition?.title}`}
          showBackBtn={true}
          showCreateBtn={false}
          showFilterBtn={true}
          basePagePath={`/competition-register/${context.competitionRegister?.id}/team`}
        />
        <div className='row mt-2 mb-3'>
          <div className='col-12 col-md-4'>
            <div className='d-flex flex-row justify-content-start'>
              <button
                onClick={() => {
                  if (checked.length === 0) {
                    return error(
                      'برای چاپ آی دی کارت لطفا ابتدا سطر های مورد نظر را انتخاب کنید.',
                    );
                  }
                  return navigate(
                    `/id-card/competition/${context.competitionRegister?.competition?.id}`,
                    {
                      state: {
                        users: checked,
                        type: 'team',
                        competition_register_id: id,
                        usersRegister: context?.users?.data,
                        sid: 'ورزشکار',
                      },
                      replace: true,
                    },
                  );
                }}
                className='btn bg-purple p-2 text-white f-13'
              >
                چاپ آی دی کارت
              </button>
            </div>
          </div>
        </div>
        <Datatable
          data={context.users?.data}
          editUrl='#'
          meta={context.users?.meta}
          search={search}
          setModalIsOpen={setModalIsOpen}
          setModalRemoveObject={setModalRemoveObject}
          disableAllActions={true}
          selectRows={true}
          setRowId={setChcked}
          rowId={checked}
          basePagePath={`/competition/${id}/team/${teamId}/users`}
          columns={[
            'تصویر',
            'نام',
            'نام خانوادگی',
            'کد ملی',
            'شماره همراه',
            'تاریخ تولد',
            'رشته',
            'وزن',
            'رده سنی',
            'زورخانه',
          ]}
          rows={[
            { name: 'personnel_image', type: 'image' },
            { name: 'name', type: 'string' },
            { name: 'last_name', type: 'string' },
            { name: 'national_card_id', type: 'string' },
            { name: 'mobile', type: 'string' },
            { name: 'birthday', type: 'date' },
            {
              name: 'sport',
              type: 'relationArray',
              showField: 'title',
              relType: 'string',
            },
            { name: 'weight.weight', type: 'relation', relType: 'string' },
            { name: 'age.title', type: 'relation', relType: 'string' },
            { name: 'gym.name', type: 'relation', relType: 'string' },
          ]}
        />
      </Master>
    </>
  );
};
export default UsersTeam;
